import ContentArea from 'components/content-area/ContentArea';
import Heading from 'components/heading/Heading';

import { IPartnerLogoBlock } from 'source/NFR.types';

const PartnerLogoBlock: React.FC<IPartnerLogoBlock> = ({ items, onPageEditing, title }) => {
  if (!items) return null;
  return (
    <div className="partner-logo-block">
      {title && <Heading onPageEditing={onPageEditing?.title}>{title}</Heading>}
      <ContentArea {...items} />
    </div>
  );
};

PartnerLogoBlock.displayName = 'PartnerLogoBlock';

export default PartnerLogoBlock;
